import React, { Component, Fragment } from 'react';
import { Segment, Header, Form, Grid, Loader, Button, Popup, Input } from 'semantic-ui-react';
import {
    fetchAcademicYears,
    fetchAllAcademicYears, fetchStudyCycle, fetchStudyType
} from '../../Lookups/util';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';
import { getProgramName } from './ExternalStudentInputForm';

class ExternalStudentExchangeInformationForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            studyCycleOptions: [],
            mobilityProgramOptions: [],
            academicYearOptions: [],
            fieldOfEducationOptions: [],
            mobilityFormatOptions: [],
            studyTypeOptions: [],
            studyProgramOptions: [],
            nonCycleProgramOptions: [],
            languageOptions: [],
            loadingOptions: true,
            onChangeStudent: props.onChangeStudent,
            onSave: props.onSave,
            onCancel: props.onCancel,
        };
    }

    componentDidMount() {
        if (!this.props.publicForm) {
            axios.get('/languages')
                .then(res => {
                    this.setState({
                        languageOptions: res.data.map(l => ({
                            key: l.id,
                            value: l,
                            text: l.name,
                        }))
                    });
                })
                .catch(() => {
                    toast(<FormattedMessage id="externalStudent.toast.errorFetchingData"/>);
                });
        }
        const axiosCallFactories =
            this.props.publicForm
                ? [
                    () => axios.get('public/external-student/study-cycles'),
                    () => axios.get('public/external-student/mobility-programs'),
                    () => axios.get('public/external-student/academic-years'),
                    () => axios.get('public/external-student/fields-of-education'),
                    () => axios.get('public/external-student/mobility-formats'),
                    () => axios.get('public/external-student/study-types'),
                    () => axios.get('public/external-student/external-student-semesters'),
                    () => axios.get('public/external-student/mobility-types'),
                    () => axios.get('public/external-student/mobility-types'), // dummy
                    () => axios.get('public/external-student/mobility-types'), // dummy
                    // () => axios.get('public/external-student/study-programs'),
                    // () => axios.get('public/external-student/non-cycle-programs'),
                ]
                : [
                    () => fetchStudyCycle(),
                    () => axios.get('/mobility-programs'),
                    () => fetchAcademicYears(),
                    () => axios.get('/field-of-education'),
                    () => axios.get('/mobility-formats'),
                    () => fetchStudyType(),
                    () => axios.get('/external-student-semesters'),
                    () => axios.get('/mobility-types'),
                    () => axios.get('/study-programs/dto-by-faculty'),
                    () => axios.get('/non-cycle-programs'),
                ];
        Promise.all(axiosCallFactories.map(fn => fn()))
            .then(([cycles, mobilityPrograms, academicYears, fieldOfEducations, mobilityFormats, studyTypes, externalStudentSemesters, mobilityTypes, studyPrograms, nonCyclePrograms]) => {
                let filteredStudyPrograms = studyPrograms.data.filter(sp =>
                    sp.studyProgram &&
                    sp.studyProgram.name &&
                    sp.studyProgram.name.trim() !== '' &&
                    sp.studyProgram.studyProgramStatus &&
                    sp.studyProgram.studyProgramBasic &&
                    sp.studyProgram.studyProgramBasic.name &&
                    sp.studyProgram.studyProgramBasic.name.trim() !== '' &&
                    (sp.studyProgram.studyProgramStatus.id === 1 || sp.studyProgram.studyProgramStatus.id === 2)
                );

                let studyProgramOptions = [],
                    nonCycleProgramOptions = [];
                if (!this.props.publicForm) {
                    studyProgramOptions = filteredStudyPrograms.map(sp => {
                        const studyCycles = (sp.studyCycles && sp.studyCycles.length)
                            ? sp.studyCycles
                            : (sp.studyProgram.studyCycles || []);

                        const studyCyclesText = studyCycles.length
                            ? ' | ' + studyCycles.map(sc => sc.name)
                            .join(', ')
                            : '';

                        const descriptionText = sp.studyProgram.description
                            ? ' | ' + sp.studyProgram.description
                            : '';

                        return {
                            key: sp.studyProgram.id,
                            value: sp.studyProgram,
                            text: sp.studyProgram.studyProgramBasic.name.trim() + ' - ' + sp.studyProgram.name.trim()
                                + studyCyclesText
                                + descriptionText,
                            description: sp.studyProgram.studyProgramBasic.comment,
                        };
                    });

                    nonCycleProgramOptions = nonCyclePrograms.data.map(el => ({
                        key: el.id,
                        value: el,
                        text: el.programName,
                        description: ((window.$locale !== 'bs' && el.nonCycleStudyProgramType.translations.length) ? el.nonCycleStudyProgramType.translations.find(e => e.language === window.$locale).name : el.nonCycleStudyProgramType.name),
                    }));
                }

                this.setState({
                    studyCycleOptions: cycles.data.map(el => ({
                        key: el.id,
                        value: el,
                        text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
                    })),
                    mobilityProgramOptions: mobilityPrograms.data.map(el => ({
                        key: el.id,
                        value: el,
                        text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
                    })),
                    fieldOfEducationOptions: fieldOfEducations.data.map(el => ({
                        key: el.id,
                        value: el,
                        text: el.name + ' | ' + el.code
                    }))
                        .sort((a, b) => b.text.localeCompare(a.text)),
                    academicYearOptions: academicYears.data.map(el => ({
                        key: el.id,
                        value: el,
                        text: el.name,
                    }))
                        .sort((a, b) => b.text.localeCompare(a.text)),
                    mobilityFormatOptions: mobilityFormats.data.map(el => ({
                        key: el.id,
                        value: el,
                        text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
                    })),
                    studyTypeOptions: studyTypes.data.map(el => ({
                        key: el.id,
                        value: el,
                        text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
                    })),
                    semesterOptions: externalStudentSemesters.data.map(el => ({
                        key: el.id,
                        value: el,
                        text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
                    })),
                    mobilityTypeOptions: mobilityTypes.data.map(el => ({
                        key: el.id,
                        value: el,
                        text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
                    })),
                    studyProgramOptions,
                    nonCycleProgramOptions,
                }, () => {
                    const { onChangeStudent } = this.props;
                    const defaultStudyType = studyTypes.data.find(s => s.name === 'redovan');
                    onChangeStudent({ studyType: defaultStudyType });
                    this.setState({
                        defaultStudyType,
                        loadingOptions: false
                    });
                });
            });
    }

    render() {
        const {
            mobilityProgramOptions,
            academicYearOptions,
            fieldOfEducationOptions,
            mobilityFormatOptions,
            studyTypeOptions,
            semesterOptions,
            mobilityTypeOptions,
            studyProgramOptions,
            nonCycleProgramOptions,
            languageOptions,
            loadingOptions,
            onSave,
            onCancel,
            onChangeStudent,
        } = this.state;
        const {
            student,
            errors,
            publicForm
        } = this.props;

        return (
            <Grid.Column>
                <Segment.Group>
                    <Segment>
                        <Header as="h3">
                            <Header.Content style={{
                                display: 'flex',
                                justifyContent: 'space-between'
                            }}>
                                <FormattedMessage id="externalStudent.exchangeData"/>
                                {this.props.edit && !loadingOptions && (
                                    <div>
                                        <Popup
                                            content={<FormattedMessage id="externalStudent.cancel"/>}
                                            position="top center"
                                            trigger={<Button floated="right" icon="cancel" basic color="red" circular
                                                             size="mini" loading={loadingOptions} onClick={onCancel}/>}
                                        />
                                        <Popup
                                            content={<FormattedMessage id="externalStudent.edit"/>}
                                            position="top center"
                                            trigger={<Button floated="right" icon="check" basic color="green" circular
                                                             size="mini" loading={loadingOptions} onClick={() => {
                                                onSave(student);
                                            }}/>}
                                        />
                                    </div>
                                )}
                            </Header.Content>
                            {publicForm &&
                                <Header.Subheader>
                                    <FormattedMessage id="externalStudent.filledByReceivingInstitution"/>
                                </Header.Subheader>
                            }
                        </Header>
                    </Segment>
                    <Segment>
                        {loadingOptions ? (
                            <div style={{
                                paddingTop: '100px',
                                paddingBottom: '100px'
                            }}><Loader active inline="centered"/></div>
                        ) : (
                            <Form>
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.mobilityProgram"/></label>
                                    <Form.Dropdown
                                        disabled={publicForm}
                                        search
                                        options={mobilityProgramOptions}
                                        value={student.mobilityProgram || null}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectMobilityProgram"/>}
                                        onChange={(e, { value }) => onChangeStudent({ mobilityProgram: value })}
                                        error={errors.mobilityProgramErr}
                                    />
                                </Form.Field>
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.studyType"/></label>
                                    <Form.Dropdown
                                        disabled={true}
                                        search
                                        options={studyTypeOptions}
                                        value={student.studyType || this.state.defaultStudyType}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectStudyType"/>}
                                        onChange={(e, { value }) => onChangeStudent({ studyType: value })}
                                        error={errors.studyTypeErr}
                                    />
                                </Form.Field>
                                <Popup
                                    content={
                                        <Fragment>
                                            <b>
                                                <FormattedMessage id="externalStudent.cyclicalStudyProgram"/>: <br/>
                                            </b>
                                            <FormattedMessage
                                                id="externalStudent.mobilityTypeInfoCyclical"/><br/>
                                            <br/>
                                            <b>
                                                <FormattedMessage id="externalStudent.nonCyclicalStudyProgram"/>: <br/>
                                            </b>
                                            <FormattedMessage
                                                id="externalStudent.mobilityTypeInfoNonCyclical"/><br/>
                                        </Fragment>
                                    }
                                    trigger={
                                        <Form.Field required>
                                            <label><FormattedMessage id="externalStudent.mobilityType"/></label>
                                            <Form.Dropdown
                                                disabled={publicForm}
                                                search
                                                options={mobilityTypeOptions}
                                                value={student.mobilityType || this.state.defaultMobilityType}
                                                selection
                                                clearable
                                                placeholder={<FormattedMessage
                                                    id="externalStudent.selectMobilityType"/>}
                                                onChange={(e, { value }) => onChangeStudent({ mobilityType: value })}
                                                error={errors.mobilityTypeErr}
                                            />
                                        </Form.Field>
                                    }
                                />
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.mobilityFormat"/></label>
                                    <Form.Dropdown
                                        disabled={publicForm}
                                        search
                                        options={mobilityFormatOptions}
                                        value={student.mobilityFormat || null}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectMobilityFormat"/>}
                                        onChange={(e, { value }) => onChangeStudent({ mobilityFormat: value })}
                                        error={errors.mobilityFormatErr}
                                    />
                                </Form.Field>
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.academicYear"/></label>
                                    <Form.Dropdown
                                        disabled={publicForm}
                                        search
                                        options={academicYearOptions}
                                        value={student.academicYear || null}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectAcademicYear"/>}
                                        onChange={(e, { value }) => {
                                            onChangeStudent({ academicYear: value });
                                        }}
                                        error={errors.academicYearErr}
                                    />
                                </Form.Field>
                                {(student.mobilityType && student.mobilityType._key === 'cycle') &&
                                    <Fragment>
                                        <Form.Field required>
                                            <label><FormattedMessage
                                                id="externalStudent.externalStudentSemester"/></label>
                                            <Form.Dropdown
                                                disabled={publicForm}
                                                search
                                                options={semesterOptions}
                                                value={student.semester || null}
                                                selection
                                                clearable
                                                placeholder={<FormattedMessage
                                                    id="externalStudent.selectExternalStudentSemester"/>}
                                                onChange={(e, { value }) => {
                                                    onChangeStudent({ semester: value });
                                                }}
                                                error={errors.semesterErr}
                                            />
                                        </Form.Field>
                                        {
                                            publicForm ?
                                                <Form.Field>
                                                    <label><FormattedMessage
                                                        id="externalStudent.studyProgram"/></label>
                                                    <FormattedMessage id="externalStudent.selectStudyProgram">
                                                        {msg => (
                                                            <Input
                                                                disabled={true}
                                                                placeholder={msg}
                                                                value={getProgramName(student)}
                                                            />
                                                        )}
                                                    </FormattedMessage>
                                                </Form.Field>
                                                :
                                                <Form.Field required>
                                                    <label><FormattedMessage id="externalStudent.studyProgram"/></label>
                                                    <Form.Dropdown
                                                        disabled={publicForm}
                                                        search
                                                        options={studyProgramOptions}
                                                        value={student.studyProgram || null}
                                                        selection
                                                        clearable
                                                        placeholder={<FormattedMessage
                                                            id="externalStudent.selectStudyProgram"/>}
                                                        onChange={(e, { value }) => onChangeStudent({ studyProgram: value })}
                                                        error={errors.studyProgramErr}
                                                    />
                                                </Form.Field>}
                                    </Fragment>
                                }
                                {(student.mobilityType && student.mobilityType._key === 'non_cycle') &&
                                    (publicForm ?
                                        <Form.Field>
                                            <label><FormattedMessage id="externalStudent.nonCycleProgram"/></label>
                                            <FormattedMessage id="externalStudent.selectNonCycleProgram">
                                                {msg => (
                                                    <Input
                                                        disabled={true}
                                                        placeholder={msg}
                                                        value={getProgramName(student)}
                                                    />
                                                )}
                                            </FormattedMessage>
                                        </Form.Field>
                                        :
                                        <Form.Field required>
                                            <label><FormattedMessage id="externalStudent.nonCycleProgram"/></label>
                                            <Form.Dropdown
                                                disabled={publicForm}
                                                search
                                                options={nonCycleProgramOptions}
                                                value={student.nonCycleProgram || null}
                                                selection
                                                clearable
                                                placeholder={<FormattedMessage
                                                    id="externalStudent.selectNonCycleProgram"/>}
                                                onChange={(e, { value }) => onChangeStudent({ nonCycleProgram: value })}
                                                error={errors.nonCycleProgramErr}
                                            />
                                        </Form.Field>)
                                }
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.fieldOfEducation"/>{' '}
                                        <a
                                            className="ui link"
                                            href="https://ec.europa.eu/eurostat/statistics-explained/index.php?title=International_Standard_Classification_of_Education_(ISCED)"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            (<FormattedMessage id={'externalStudent.isced'}/>)
                                        </a>
                                    </label>

                                    <Form.Dropdown
                                        disabled={publicForm}
                                        search
                                        options={fieldOfEducationOptions}
                                        value={student.fieldOfEducation || null}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectFieldOfEducation"/>}
                                        onChange={(e, { value }) => onChangeStudent({ fieldOfEducation: value })}
                                        error={errors.fieldOfEducationErr}
                                    />
                                </Form.Field>
                                {!publicForm &&
                                    <Form.Field>
                                        <label><FormattedMessage id="externalStudent.scholarshipAmount"/></label>
                                        <FormattedMessage id="externalStudent.enterScholarshipAmount">
                                            {msg => (
                                                <Input
                                                    placeholder={msg}
                                                    type="number"
                                                    step="0.01"
                                                    value={student.scholarshipAmount || ''}
                                                    onChange={(e, { value }) => onChangeStudent({ scholarshipAmount: parseFloat(value) || null })}
                                                />
                                            )}
                                        </FormattedMessage>
                                    </Form.Field>
                                }
                                {!publicForm &&
                                    <Form.Field>
                                        <label><FormattedMessage id="externalStudent.languages"/></label>
                                        <Form.Dropdown
                                            search
                                            multiple
                                            options={languageOptions}
                                            value={student.languages || []}
                                            selection
                                            clearable
                                            placeholder={<FormattedMessage id="externalStudent.selectLanguages"/>}
                                            onChange={(e, { value }) => onChangeStudent({ languages: value })}
                                        />
                                    </Form.Field>
                                }
                            </Form>
                        )}
                    </Segment>
                </Segment.Group>
            </Grid.Column>
        );
    }
}

export default ExternalStudentExchangeInformationForm;



// WEBPACK FOOTER //
// ./src/views/ExternalStudents/ExternalStudentForms/ExternalStudentExchangeInformationForm.js